import { useForm } from 'react-hook-form-mui';

import { useResolveFileResolution } from 'src/use-cases/internalDashboard/useFileResolution';
import { ROW_ACTION_TYPE, TUpdateValues } from './types';
import { ModalUpdateBase } from './ModalUpdateBase';
import { FormResolutionMessage } from './FormResolutionMessage';
import { useInternalDashboardSelector } from './Selector';

const defaultValues = {
  message: '',
};

export const ModalResolutionMessage = () => {
  const { selectedRow, filterParams, setIsActionLoading, stopRowAction } = useInternalDashboardSelector();
  const { mutateAsync: resolve } = useResolveFileResolution();
  const formContext = useForm({
    defaultValues: defaultValues as TUpdateValues,
  });

  const onSubmitForm = async (values: TUpdateValues) => {
    setIsActionLoading(true);

    const updatesData = {
      id: selectedRow?.id,
      data: {
        status: selectedRow?.resolutionStatus,
        message: values?.message || '',
        resolutionType: selectedRow?.resolutionType,
      },
      params: filterParams,
    };
    await resolve(updatesData);

    setIsActionLoading(false);
    stopRowAction();
  };

  return (
    <ModalUpdateBase title='Resolution Message' formContext={formContext} actionType={ROW_ACTION_TYPE.RESOLUTION_MESSAGE} onSubmit={onSubmitForm}>
      <>
        <p className='text-16 text-blue_grey-80'>View or Edit Resolution Description</p>
        <div className='mt-20'>
          <FormResolutionMessage />
        </div>
      </>
    </ModalUpdateBase>
  );
};
